// Only the mini-program anonymous product entry carries this one-shot marker.
export function createMiniProductEntryGuard(clearSession, isMiniProgram = () => false) {
  return (to, from, next) => {
    if (!isMiniProgram() || to.query.miniSession !== "anonymous") {
      next();
      return;
    }
    clearSession();
    const query = { ...to.query };
    delete query.miniSession;
    next({ path: to.path, query, hash: to.hash, replace: true });
  };
}
